import React from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    Typography,
} from "@mui/material";
import AlertMessage from "../Common/Alert/AlertMessage";

export default function ErrorHandler({ error, breadCrumb }) {
    let message = "Error";

    if (error.errorCode === 404) {
        message = "Resource not found";
    }

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    {breadCrumb}
                </Grid>

                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography component="h2" variant="h2">
                                    {error.errorCode}
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <AlertMessage
                                    severity="error"
                                    message={message}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}
